import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactCountdown from 'react-countdown';
import Timer from './timer';

const WithdrawCountdown = ({ date, onDone }) => {
  const [isFinished, setIsFinished] = useState(new Date().getTime() > date);

  if (isFinished) {
    return 'Available Now';
  }

  return (
    <>
      Available in:&nbsp;
      <ReactCountdown
        date={date}
        renderer={(props) => <Timer {...props} withSeconds />}
        onComplete={() => {
          setIsFinished(true);
          onDone();
        }}
      />
    </>
  );
};

WithdrawCountdown.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onDone: PropTypes.func.isRequired,
};

export default WithdrawCountdown;
